export enum PocketsReportInterval {
  Month = 0,
  Week = 1,
  Quarter = 2,
  Year = 3,
  Day = 4,
}
